import { render } from "./RecordCell.vue?vue&type=template&id=1a8693ce&scoped=true"
import script from "./RecordCell.vue?vue&type=script&lang=js"
export * from "./RecordCell.vue?vue&type=script&lang=js"

import "./RecordCell.vue?vue&type=style&index=0&id=1a8693ce&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a8693ce"]])

export default __exports__